import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import wax from '../wax';
import AnchorLink from 'anchor-link';
import AnchorLinkBrowserTransport from 'anchor-link-browser-transport';
import './Play.css';
import { useLocation } from 'react-router-dom';

function Play() {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const referrer = searchParams.get('ref');

  const [account, setAccount] = useState(null);
  const [errorMessage, setErrorMessage] = useState('');
  const navigate = useNavigate();
  const { wallet } = useParams();

  const getLoggedInUser = () => localStorage.getItem('loggedInUser');
  const getLoginMethod = () => localStorage.getItem('loginMethod');

  useEffect(() => {
    const loggedInUser = getLoggedInUser();
    const location = window.location;
    const params = new URLSearchParams(location.search);
    const ref = params.get('ref');

    if (!wallet && loggedInUser) {
      const refPart = ref ? `?ref=${ref}` : '';
      navigate(`/play/${loggedInUser}${refPart}`);
    }
  }, [wallet, navigate]);

  const handleCloudLogin = async () => {
    try {
      const userAccount = await wax.login();
      setAccount(userAccount);
      localStorage.setItem('loggedInUser', userAccount);
      localStorage.setItem('loginMethod', 'cloud');
      navigate(`/play/${userAccount}${referrer ? `?ref=${referrer}` : ''}`);
    } catch (err) {
      setErrorMessage('WAX Cloud Wallet login failed: ' + err.message);
      console.error('Cloud login failed:', err);
    }
  };

  const handleAnchorLogin = async () => {
    try {
      const transport = new AnchorLinkBrowserTransport();
      const link = new AnchorLink({
        transport,
        chains: [{
          chainId: '1064487b3cd1a897ce03ae5b6a865651747e2e152090f99c1d19d44e01aea5a4',
          nodeUrl: 'https://wax.greymass.com',
          token: 'WAX',
          label: 'WAX Mainnet'
        },
        {
          chainId: 'f16b1833c747c43682f4386fca9cbb327929334a762755ebec17f6f23c9b8a12',
          nodeUrl: 'https://waxtestnet.greymass.com',
          token: 'WAX',
          label: 'WAX Testnet'
        }]
      });

      /*
        {
          chainId: 'f16b1833c747c43682f4386fca9cbb327929334a762755ebec17f6f23c9b8a12',
          nodeUrl: 'https://waxtestnet.greymass.com',
          token: 'WAX',            
          label: 'WAX Testnet'      
        }
      */
      const result = await link.login('ranchersland');
      const accountName = result.session.auth.actor.toString();

      setAccount(accountName);
      localStorage.setItem('loggedInUser', accountName);
      localStorage.setItem('loginMethod', 'anchor');


      navigate(`/play/${accountName}${referrer ? `?ref=${referrer}` : ''}`);
    } catch (err) {
      setErrorMessage('Anchor login failed: ' + err.message);
      console.error('Anchor login failed:', err);
    }
  };

  const shouldShowLogin = !getLoggedInUser();

  if (shouldShowLogin && !wallet) {
    return (
      <div className="play-container">
        <div className="login-box">
          <h2>Sign in to Play</h2>
          <div className="wallet-buttons">
            <button onClick={handleCloudLogin} className="wallet-button wax-button">
              WAX Cloud Wallet
            </button>
            <button onClick={handleAnchorLogin} className="wallet-button anchor-button">
              Anchor Wallet
            </button>
          </div>
          {errorMessage && <div className="login-error">{errorMessage}</div>}
        </div>
      </div>
    );
  }

  return (
    <div className="play-container">
      <h2>Welcome to Ranchers Land</h2>
      <p>Viewing wallet: <strong>{wallet}</strong></p>
      <p>Logged in as: <strong>{getLoggedInUser()}</strong> ({getLoginMethod()})</p>

      <button onClick={() => alert(`Signing as ${getLoggedInUser()} via ${getLoginMethod()}`)}>
        Example Signed Action
      </button>
    </div>
  );
}

export default Play;
